/**
 * Created by lenovo on 2017/5/11.
 */
import React, {Component, PropTypes} from 'react';
import {Link, browserHistory} from "react-router";
import ErrorSpan from "../../../component/errorSpan";

var moment = require('moment');
import FormInput from 'CONFIG/component/form/formInput'
import FormInputSimple from 'CONFIG/component/form/formInputSimple'
import FormSelect from 'CONFIG/component/form/formSelect'
var clearFlag = false;
import {ellaUrl} from '../../../path.config'
import Tip from 'COMPONENT/tip'
import {resultTip,language,errorShow,errToSuc} from 'UTIL/common'
import userService from 'SERVICES/ella/userService'
const roleList = [];
import ellaService from 'SERVICES/purifier/ella/ellaService'
import {getNowFormatDate} from 'CONFIG/function'
function nodeChildren(nodeList) {
    for (let i in nodeList) {
        var arr = {}
        arr = {
            id: nodeList[i].id,
            pId: nodeList[i].pId,
            name: nodeList[i].name
        };
        roleList.push(arr);
        if (nodeList[i].children.length > 0) {
            nodeChildren(nodeList[i].children)
        }
    }
    return roleList;
}
export default class NoramlUserEdit extends Component {
    constructor(props) {
        super(props);
        this.btnSubmit = this.btnSubmit.bind(this);
        this.fetchExtendsValue = this.fetchExtendsValue.bind(this);
        this.state = {
            roleList: [],
            userType: [],
            extendsValue: [],
            url: ellaUrl
        };
    }

    componentDidMount() {
        var id = this.props.params.id;
        ellaService.userToUpdate(id).then(data=>{
            console.log(data)
            if (data.data != null) {
                var userBase = data.data.userBase;
                var nodeVos = JSON.parse(data.data.nodeVos);
                var roleList = data.data.roleList;
                var selectRole = data.data.selectRole;
                var orgs = data.data.orgs;
                var userType = data.data.userType;
                var userExtendValues = data.data.userExtendValues;


                this.setState({
                    map: data.data,
                    userBase: data.data.userBase,
                    roleList: data.data.roleList,
                    dvcTypes: userBase.dvcTypes,
                    selectRole: selectRole,
                    userType: userType,
                    userExtendValues: userExtendValues,
                })
                this.fetchExtendsValue(userBase.userTypeId);

                $("#loginName").val(userBase.loginName);
                $("#realName").val(userBase.realName);
                $("#telephone").val(userBase.telephone);
                $("#email").val(userBase.email);
                $("#address").val(userBase.address);
                $("#telephone").val(userBase.telephone);
                $("#userTypeId").val(userBase.userTypeId);

            }
        })
    }

    fetchExtendsValue(id) {
        ellaService.getByUserTypeIdUser(id).then(data=>{
            console.log(data)
            var value = data.data;
            if (value != null) {
                var extendsValue = value.page.records;
                this.setState({
                    extendsValue: extendsValue,
                })
            }else {
                this.setState({
                    extendsValue : [],
                })
            }
        })
    }
    onchange() {
        var typeId = 19;
        if (typeId == 2) {
            $("#org").hide();
        } else {
            $("#org").show();
        }
        this.fetchExtendsValue(typeId);
    }

    btnSubmit(event) {
        event.preventDefault();
        errToSuc();
        var remark = $.trim($("#remark").val());
        var loginName = $.trim($("#loginName").val());
        var realName = $.trim($("#realName").val());
        var telephone = $.trim($("#telephone").val());
        var email = $.trim($("#email").val());
        var address =$.trim($("#address").val());
        var userTypeId = 3;
        var chk_value = [];
        $('input[id="roleType"]:checked').each(function () {
            chk_value.push($(this).val());
        });
        var json = {
            id :this.props.params.id,
            loginName: loginName,
            realName: realName,
            telephone: telephone,
            email: email,
            address: address,
            userTypeId: userTypeId,
        };
        console.log(json)
        var errorMessage = '';
        var ids = ['loginName','address'];
        for(let i in ids){
            if(json[ids[i]]==''){
                errorShow(ids[i]);
            }
        }
        if($("[name='error']").length == 0){
            if(json.telephone == ''&&json.email== ''){
                $("#warning_msg").text('邮箱或电话必填其一！');
                $("#warning_tip").removeClass("hidden");
                $("#warning_tip").focus();
                setTimeout(function() {
                    $("#warning_tip").addClass("hidden");
                }, 4000);
            }else {
                var userBody  = JSON.stringify(json);
                userService.saveUser({userBody}).then(data =>{
                    resultTip(data,"/ella/user/user/normalUser");
                })
            }
        }
    }
    render() {
        const _this = this;
        //
        var selectrole = this.state.selectRole;
        const roleList = this.state.roleList.map(function (str, index) {
            var div = <div className="col-xs-3"><input className="input-hidden" id="roleType" value={str.id}
                                                       type="checkbox"></input>
                <span className="checkbox-body"></span>
                <span className="checkbox-text">{str.roleName}</span></div>;
            if (selectrole != null && selectrole.indexOf(str.id) != -1)
                div = <div className="col-xs-3"><input className="input-hidden" id="roleType" value={str.id}
                                                       type="checkbox" checked></input>
                    <span className="checkbox-body"></span>
                    <span className="checkbox-text">{str.roleName}</span></div>;

            return div;
        });
        //用户类型
        const userType = this.state.userType.map(function (str, index) {
            return <option value={str.id}>{str.name}</option>
        })


        return (
            <div >
                <section className="content-header ">
                    <h1> {language()['userManage']}
                        <small>{language()['normalUserEdit']}</small>
                    </h1>
                </section>
                <section className="content">
                    <div className="box box-primary color-palette-box">
                        <div className="box-header with-border">
                            <i className="fa fa-plus-circle"></i>
                            <h3 className="box-title">{language()['normalUserEdit']}</h3>
                        </div>
                        <div className="box-body">
                            <Tip ids="" />
                            <form id="micaFrom" className="form-horizontal">
                                <FormInput name="loginName" id="loginName"/>
                                <FormInputSimple name="realName" id="realName"/>
                                <FormInputSimple name="telephone" id="telephone"/>
                                <FormInputSimple name="email" id="email"/>
                                <FormInput name="address" id="address"/>

                                {/*<div className="row form-group">*/}
                                    {/*<label className="multi-label control-label col-xs-2">选择角色</label>*/}
                                    {/*<div className="col-xs-10" style={{marginBottom: "15px"}}>*/}
                                        {/*{roleList}*/}
                                    {/*</div>*/}
                                {/*</div>*/}
                                <div className="row form-group">
                                    <div className="col-xs-2"></div>
                                    <div className="col-xs-1 text-center">
                                        <a className="btn btn-success" onClick={this.btnSubmit}>{language()['submit']}</a>
                                    </div>
                                    <div className="col-xs-1 text-center">
                                        <Link to="/ella/user/user/normalUser" className="btn btn-default btn-md">
                                            {language()['return']}
                                        </Link>
                                    </div>
                                </div>
                            </form>
                        </div>
                    </div>
                </section>
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./modules/ella/user/user/normalUserEdit.js